import {
  useMutation,
  useQueryClient,
  UseMutationResult,
} from "@tanstack/react-query";
import { AddNewDGToSite, AddNewSite } from "../../api/api"; // Adjust the import path as necessary
import { useCallback, useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import useAppContextProvider from "../../AppContext/useAppContextProvider";

type DGResult = {
  status: string;
  Msg?: string;
  errorCode?: string;
};

export const usePostNewDG = (): UseMutationResult<
  DGResult,
  Error
> => {
  const queryClient = useQueryClient();

  const { getAccessTokenSilently, isAuthenticated } =
    useAuth0();
  const mutation = useMutation({
    mutationFn: ({
      siteName,
      dgname,
      token,
    }: {
      siteName: string;
      dgname: string;
      token: string;
    }) => AddNewDGToSite({ siteName, dgname }, token),
    onSuccess: async (data) => {
      if (data.status === "error") {
        console.log("Error adding site:", data);
      } else {
        console.log("Site added successfully");
      }
    },
    onError: (error) => {
      console.error("Error adding site:", error);
    },
  });

  const mutateWithToken = useCallback(
    async (
      siteName: string,
      dgname: string,
      options: {
        onSuccess?: (data: DGResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      } = { onSuccess: () => {}, onError: () => {} }
    ) => {
      const token = await getAccessTokenSilently();
      mutation.mutate(
        {
          siteName,
          dgname,
          token,
        },
        {
          onSuccess: options.onSuccess,
          onError: options.onError,
          onSettled: options.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return {
    ...mutation,
    mutate: (
      variables: { siteName: string; dgname: string },
      options?: {
        onSuccess?: (data: DGResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      mutateWithToken(
        variables.siteName,
        variables.dgname,
        options
      );
    },
  };
};
